const CommunicationsText = () =>
  import(/* webpackChunkName: 'CommunicationsText' */ '@/Text/Index');
const CommunicationsBulkText = () =>
  import(/* webpackChunkName: 'CommunicationsBulkText' */ '@/Text/BulkCreate');
const CommunicationsEmail = () =>
  import(/* webpackChunkName: 'CommunicationsEmail' */ '@/Email/Index');
const EmailManagement = () =>
  import(/* webpackChunkName: 'EmailManagement' */ '@/Email/EmailManagement');
const Text2Sell = () =>
  import(/* webpackChunkName: 'Text2Sell' */ '@/Communications/components/Text2Sell');
const OptInForm = () =>
  import(/* webpackChunkName: 'OptInForm' */ '@/Communications/components/OptInForm');

const VerifyEmailDialer = () =>
  import(/* webpackChunkName: 'VerifyEmailDialer' */ '@/Communications/components/VerifyEmailDialer')

export default [
  // text
  {
    path: '/communications/text',
    component: CommunicationsText,
    name: 'communications.text',
    meta: { auth: true, howToVideoFeature: 'text' },
    props: {
      route: 'communications.text'
    }
  },
  {
    path: '/communications/text/bulk',
    component: CommunicationsBulkText,
    name: 'communications.text.bulk',
    meta: { auth: true },
  },
  // email
  {
    path: '/communications/email',
    component: CommunicationsEmail,
    name: 'communications.email',
    meta: { auth: true, howToVideoFeature: 'email' },
  },
  {
    path: '/communications/email/management',
    component: EmailManagement,
    name: 'communications.email.management',
    meta: { auth: true },
  },
  // text2sell
  {
    path: '/communications/text2sell',
    component: Text2Sell,
    name: 'communications.text2sell',
    meta: { auth: true, howToVideoFeature: 'text2sell' },
  },
  {
    path: '/communications/text/text-management',
    component: CommunicationsText,
    name: 'communications.text.text-management',
    meta: { auth: true,  howToVideoFeature: 'text' },
    props: {
      route: 'communications.text.text-management'
    }
  },
  // opt-in form
  {
    path: '/communications/opt-in-form',
    component: OptInForm,
    name: 'communications.opt-in-form',
    meta: { auth: false },
  },
  {
    path: '/communications/verify-dialer-email',
    component: VerifyEmailDialer,
    name: 'communications.verify-dialer-email',
    meta: { auth: true },
  }
];
